import { render } from "./Gameboard_Story_Window.vue?vue&type=template&id=727c2327"
import script from "./Gameboard_Story_Window.vue?vue&type=script&lang=js"
export * from "./Gameboard_Story_Window.vue?vue&type=script&lang=js"

import "./Gameboard_Story_Window.vue?vue&type=style&index=0&id=727c2327&lang=scss"
script.render = render

export default script